<template>
  <div class="container bg-white">
    <div v-if="false">
      {{ tempText }}
    </div>
    <!-- logo -->
    <div class="logo-list">
      <img :src="logoImgPath" alt />
    </div>
    <!-- 表单 -->
    <div class="form-list">
      <!-- 置顶邀请码 -->
      <div v-if="isUrlGetInviteCodeShow">
        <!-- pc浏览器测试时使用 @keyup="handleInviteCodeKeyUp" -->
        <input type="tel" v-model="inviteName" placeholder="请输入邀请码" :disabled="inviteCodeDisabled"
          @keyup="handleInviteCodeKeyUp" />
        <!-- 2020.8.28新加， 如果url传入的邀请码不存在，则认为允许客户输入邀请码 -->
        <!-- 允许输入邀请码时，显示此图标 -->
        <div v-show="!inviteCode && inviteName && isNoGetSmsCode" @click="handleClearInviteCodeClick">
          <img :src="require('@/assets/clear.png')" alt />
        </div>
      </div>
      <!-- 手机号 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handleMobileNumKeyUp" -->
        <input type="tel" v-model="mobileNum" maxlength="13" placeholder="请输入手机号码" @keyup="handleMobileNumKeyUp" />
        <div v-show="mobileNum" @click="handleClearMobileNumClick">
          <img :src="require('@/assets/clear.png')" alt />
        </div>
      </div>
      <!-- 验证码 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handleCodeKeyUp" -->
        <input type="tel" v-model="validateCode" maxlength="6" placeholder="请输入验证码" @input="handleCodeKeyUp" />
        <button :disabled="codeBtnDisabled" @click="handleCodeBtnClick">{{ codeBtnLabel }}</button>
      </div>
      <!-- 密码 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handlePwd1KeyUp" -->
        <input :type="pwd1InputType" v-model="pwd1" maxlength="30" placeholder="登录密码(6位以上数字或字母)"
          @input="handlePwd1KeyUp" />
        <div @click="handleShowPwd1Click">
          <svg-icon :icon-class="pwd1SvgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <!-- 确认密码 -->
      <div>
        <!-- pc浏览器测试时使用 @keyup="handlePwd2KeyUp" -->
        <input :type="pwd2InputType" v-model="pwd2" maxlength="30" placeholder="确认登录密码" @input="handlePwd2KeyUp" />
        <div @click="handleShowPwd2Click">
          <svg-icon :icon-class="pwd2SvgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <!--2024.4.19 销售码-->
      <div v-if="isReferralCode">
        <input type="tel" v-model="referralCode"  maxlength="30" placeholder="请输入销售码" @keyup="handleReferralCodeKeyUp" />
      </div>
      <!-- 邀请码 -->
      <div v-if="isConfigGetInviteCodeShow">
        <!-- pc浏览器测试时使用 @keyup="handleInviteCodeKeyUp" -->
        <input type="tel" v-model="inviteName" placeholder="请输入邀请码" :disabled="inviteCodeDisabled"
          @keyup="handleInviteCodeKeyUp" />
        <!-- 2020.8.28新加， 如果url传入的邀请码不存在，则认为允许客户输入邀请码 -->
        <!-- 允许输入邀请码时，显示此图标 -->
        <div v-show="!inviteCode && inviteName && isNoGetSmsCode" @click="handleClearInviteCodeClick">
          <img :src="require('@/assets/clear.png')" alt />
        </div>
      </div>
    </div>
    <!-- 注册协议 -->
    <div class="check-list">
      <div @click="handleCheckBoxClick">
        <svg-icon :icon-class="checkboxSvgPath" class-name="cur-icon"></svg-icon>
      </div>
      <span>
        我已阅读并同意
        <span @click="handleToAgreementClick">《注册协议》</span>
      </span>
    </div>
    <!-- 按钮 -->
    <div class="button-list">
      <mt-button type="primary" size="large" plain v-if="downloadBtnIsShow && isQrCode"
        @click="handleDownloadBtnClick">已有账户直接下载APP</mt-button>
      <mt-button type="primary" size="large" :disabled="registerBtnDisabled" @click="handleRegisterBtnClick">
        注册
      </mt-button>
    </div>
    <mt-popup class="register-agreement" v-model="agreementVisible">
      <div class="container">
        <div class="title">恒信通注册协议</div>
        <div class="content" v-html="hasNameAgreementText"></div>
        <div class="btn" @click="handleAgreementClose">关闭</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
/* global
    PUBLIC_TOKEN,
    PUBLIC_REGISTER_LOGO,
    PUBLIC_REGISTER_DOWNLOAD_BTN,
    PUBLIC_WELCOME_CODE,
    PUBLIC_WELCOME_NAME,
    PUBLIC_WELCOME_SOURCE_TYPE,
    PUBLIC_WELCOME_NEED_CODE,
    PUBLIC_APP_NAME,
    PUBLIC_AGREEMENT_TEXT,
    PUBLIC_WELCOME_INVITEAGENTTYPE,
    PUBLIC_USER_AGENT,
    PUBLIC_WELCOME_QRCODE,
    PUBLIC_REGISTER_INTERFACE_FLAG,
    BMap,
    BMAP_STATUS_SUCCESS,
    qq,
    qq_map_service_key,
    PUBLIC_SYSTEM_FLAG,
    PUBLIC_MOBILE_REGEXP,
    PUBLIC_PRODUCT,
    android_download_url,
    ios_download_url
*/

/* exported PUBLIC_TOKEN */

import { Indicator, MessageBox } from 'mint-ui';
import { CusToast, CusAlert } from '@/utils/CustomToast';
import { GetTokenBySh, GetTokenByDls, GetConfigBySh, GetConfigByDls, GetMobileVerificationCode, GetSMSCode, RegUser, AddUser } from '@/api/interface';
import { SucceedHandle, SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'Register',
  comments: { SvgIcon },
  data() {
    return {
      logoImgPath: require('@/assets/' + PUBLIC_REGISTER_LOGO),
      pwd1SvgEyePath: 'hide_money',
      pwd2SvgEyePath: 'hide_money',
      checkboxSvgPath: 'selected_coupons',
      pwd1InputType: 'password',
      pwd2InputType: 'password',
      timing: null,
      codeBtnDisabled: false,
      codeBtnLabel: '获取验证码',
      currentCheckedState: true,
      registerBtnDisabled: false,
      isQrCode: false,
      isReferralCode: false,
      downloadBtnIsShow: PUBLIC_REGISTER_DOWNLOAD_BTN,
      mobileNum: '',
      validateCode: '',
      pwd1: '',
      pwd2: '',
      inviteCode: PUBLIC_WELCOME_CODE,
      inviteName: PUBLIC_WELCOME_NAME || PUBLIC_WELCOME_CODE,
      inviteSourceType: PUBLIC_WELCOME_SOURCE_TYPE || 0,
      inviteCodeDisabled: true, // 2020.8.28 邀请码的有效性
      isNoGetSmsCode: true, // 是否点击了获取验证码
      configGetIsNeedInviteCode: true, // config中返回是否显示邀请码的控制标识
      urlGetIsNeedInviteCode: PUBLIC_WELCOME_NEED_CODE, // url中传入是否显示邀请码的控制标识
      agreementVisible: false,
      appName: PUBLIC_APP_NAME,
      agreementText: PUBLIC_AGREEMENT_TEXT,
      inviteAgentType: PUBLIC_WELCOME_INVITEAGENTTYPE, // 代理运营模式
      city: '',
      cityCode: '',
      tempText: PUBLIC_USER_AGENT,
      referralCode: PUBLIC_REFERRAL_CODE || "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 判断入口路径
      if (PUBLIC_WELCOME_QRCODE === '') {
        this.isQrCode = true;
      } else if (PUBLIC_WELCOME_QRCODE === '0' || PUBLIC_WELCOME_QRCODE === false) {
        this.isQrCode = false;
      } else {
        this.isQrCode = true;
      }
      // 显示缓存的信息
      this.mobileNum = sessionStorage.getItem('reg_mobile') || '';
      this.validateCode = sessionStorage.getItem('reg_code') || '';
      this.pwd1 = sessionStorage.getItem('reg_pwd1') || '';
      this.pwd2 = sessionStorage.getItem('reg_pwd2') || '';
      !this.inviteCode && (this.inviteName = sessionStorage.getItem('reg_invite') || '');
      !this.referralCode && (this.referralCode = sessionStorage.getItem('reg_ref_code') || '');
      // 2020.8.28 新加 判断url中是否有传入的邀请码
      // 如果没有传入邀请码，则允许客户手动输入邀请码
      !this.inviteCode && (this.inviteCodeDisabled = false);
      // 根据标识调用不同接口
      switch (PUBLIC_REGISTER_INTERFACE_FLAG) {
        case '商户':
          this.isReferralCode = false;
          this.apiGetTokenBySh();
          break;
        case '代理商':
          this.isReferralCode = true;
          this.apiGetTokenByDls();
          break;
      }
    });
  },
  computed: {
    hasNameAgreementText() {
      return this.agreementText.replace(/tmpCustomAppName/g, this.appName);
    },
    isUrlGetInviteCodeShow() {
      if (this.urlGetIsNeedInviteCode === '1') return true;
      return false;
    },
    isConfigGetInviteCodeShow() {
      if (this.urlGetIsNeedInviteCode === '1') return false;
      if (this.urlGetIsNeedInviteCode === '' || this.urlGetIsNeedInviteCode === '0') {
        return this.configGetIsNeedInviteCode;
      }
      return true;
    },
  },
  methods: {
    // 百度地图API获取经纬度
    BMapGeolocation(ok = null, err = null) {
      const that = this;
      const baiduGeolocation = new BMap.Geolocation();
      const baiduGeocoder = new BMap.Geocoder();
      Indicator.open('加载中，请稍后…');
      baiduGeolocation.getCurrentPosition(function (r) {
        if (this.getStatus() === BMAP_STATUS_SUCCESS) {
          baiduGeocoder.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (result) {
            if (result) {
              Indicator.close();
              that.city = result.addressComponents.city;
            }
          });
          ok && ok();
        } else {
          Indicator.close();
          CusAlert(that.getWxGeolocationErrMsg());
          err && err();
        }
      });
    },
    // 腾讯地图API获取经纬度
    QQMapGeolocation(ok = null, err = null) {
      Indicator.open('加载中，请稍后…');
      new qq.maps.Geolocation(qq_map_service_key, 'JuhPay').getLocation(
        position => {
          Indicator.close();
          this.city = position.city;
          ok && ok();
        },
        () => {
          Indicator.close();
          CusAlert(this.getZfbGeolocationErrMsg());
          err && err();
        },
        { timeout: 6000 }
      );
    },
    // 支付宝未获取到地理位置时返回的错误信息
    getZfbGeolocationErrMsg() {
      let msg = '获取地理位置失败，无法完成注册';
      if (PUBLIC_SYSTEM_FLAG === 'android') {
        msg += '\n请您通过“应用管理”将”支付宝“的”获取位置信息权限”设置成“允许”';
      } else if (PUBLIC_SYSTEM_FLAG === 'ios') {
        msg +=
          '\n温馨提示：\n苹果用户如果无法弹出“位置授权”对话框，请按以下步骤进行设置：\n1.通过“设置-隐私-定位服务”将微信设置为允许访问位置信息\n2.通过”设置-通用-还原-还原位置与隐私“重置微信位置信息授权';
      } else {
        msg += '';
      }
      return msg;
    },
    // 微信未获取到地理位置时返回的错误信息
    getWxGeolocationErrMsg() {
      const str = PUBLIC_SYSTEM_FLAG === 'android' ? '确定' : '好';
      let msg = `获取地理位置失败，无法完成注册\n请点击右上角的“···”，选择“刷新”\n在弹出的“位置授权”对话框中选择“${str}”`;
      if (PUBLIC_SYSTEM_FLAG === 'ios') {
        msg +=
          '\n温馨提示：\n苹果用户如果无法弹出“位置授权”对话框，请按以下步骤进行设置：\n1.通过“设置-隐私-定位服务”将微信设置为允许访问位置信息\n2.通过”设置-通用-还原-还原位置与隐私“重置微信位置信息授权';
      }
      return msg;
    },
    // 验证手机号码
    validateMobileNumVal() {
      const val = this.mobileNum.replace(/\s/gi, '');
      if (val === '') {
        CusToast('手机号码不能为空');
        return 'err';
      }
      const regExp = PUBLIC_MOBILE_REGEXP;
      if (!regExp.test(val)) {
        CusToast('手机号码格式不正确');
        return 'err';
      }
      return 'ok';
    },
    // 验证短信验证码
    validateCodeVal() {
      if (this.validateCode === '') {
        CusToast('短信验证码不能为空');
        return 'err';
      }
      return 'ok';
    },
    // 验证密码框1
    validatePwd1Val() {
      if (this.pwd1 === '') {
        CusToast('登录密码不能为空');
        return 'err';
      }
      const arr = this.pwd1.split('');
      const isOk = /^[A-Za-z0-9]+$/.test(this.pwd1);
      if (arr.length < 6 || !isOk) {
        CusToast('登录密码为6位以上数字或字母');
        return 'err';
      }
      // 验证都是数字的情况下不能是相同\连续的数字
      if (/^[0-9]*[1-9][0-9]*$/.test(this.pwd1)) {
        const differ = [];

        const pwdArr = this.pwd1.split('');

        let count0 = 0;

        let count1 = 0;

        let count2 = 0;
        for (let i = 0; i < pwdArr.length - 1; ++i) {
          differ.push(pwdArr[i + 1] - pwdArr[i]);
        }
        for (let i = 0; i < differ.length; i++) {
          differ[i] === 0 && count0++;
          differ[i] === 1 && count1++;
          differ[i] === -1 && count2++;
        }
        if (count0 === differ.length) {
          CusToast('密码不能是重复的数字');
          return 'err';
        }
        if (count1 === differ.length) {
          CusToast('密码不能是连续的数字');
          return 'err';
        }
        if (count2 === differ.length) {
          CusToast('密码不能是连续的数字');
          return 'err';
        }
      }
      return 'ok';
    },
    // 验证再次输入密码框
    validatePwd2Val() {
      if (this.pwd1 !== this.pwd2) {
        CusToast('两次密码输入的不一致');
        return 'err';
      }
      return 'ok';
    },
    // 验证邀请码
    validateInviteCodeVal() {
      // 2020.8.28新加， 如果url传入的邀请码不存在，则认为允许客户输入邀请码
      // 客户输入邀请码后需要验证
      // 不能小于/大于11位
      // 符合手机号码格式
      // 2020.11.12新加，由url控制邀请码时验证邀请码必填
      const val = this.inviteName.replace(/\s/gi, '');
      if (!this.inviteCode) {
        if (val.length > 11) {
          CusToast('邀请码位数过长');
          return 'err';
        }
        if (val.length > 0 && val.length < 11) {
          CusToast('邀请码位数过短');
          return 'err';
        }
        const regExp = PUBLIC_MOBILE_REGEXP;
        if (val && !regExp.test(val)) {
          CusToast('邀请码格式不正确');
          return 'err';
        }
        if (this.isUrlGetInviteCodeShow) {
          if (val === '') {
            CusToast('邀请码不能为空');
            return 'err';
          }
        }
      }
      return 'ok';
    },
    // 结束倒计时
    endTiming() {
      clearInterval(this.timing);
      this.codeBtnDisabled = false;
      this.codeBtnLabel = '获取验证码';
    },
    // 调用接口，获得token （商户使用）
    apiGetTokenBySh() {
      GetTokenBySh()
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            PUBLIC_TOKEN = res.data.token;
            // 2020.11.6 添加获取config配置信息 （代理商使用）
            GetConfigBySh()
              .then(res => {
                const msg = SucceedHandle(res.code, res.msg, () => {
                  this.configGetIsNeedInviteCode = res.data.needWelcomeCode;
                });
                msg && CusToast(msg);
              })
              .catch(err => {
                const msg = NotSucceedHandle(err.message);
                msg && CusToast(msg);
              });
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获得token （代理商使用）
    apiGetTokenByDls() {
      GetTokenByDls()
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            PUBLIC_TOKEN = res.data.token;
            // 2020.11.6 添加获取config配置信息 （代理商使用）
            GetConfigByDls()
              .then(res => {
                const msg = SucceedHandle(res.code, res.msg, () => {
                  this.configGetIsNeedInviteCode = res.data.needWelcomeCode;
                });
                msg && CusToast(msg);
              })
              .catch(err => {
                const msg = NotSucceedHandle(err.message);
                msg && CusToast(msg);
              });
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获取注册码（商户使用）
    apiGetMobileVerificationCode(welcomeCode = '') {
      // 2020.8.28新加， 如果url传入的邀请码不存在，则认为允许客户输入邀请码
      // 允许客户输入邀请码时先校验邀请码
      // 再获取格式正确的邀请码
      // 2020.11.12新加，如果由url控制邀请码是否显示，则先验证邀请码，反之则验证手机号
      if (this.isUrlGetInviteCodeShow) {
        if (this.validateInviteCodeVal() === 'err') return;
        if (this.validateMobileNumVal() === 'err') return;
      } else {
        if (this.validateMobileNumVal() === 'err') return;
        if (this.validateInviteCodeVal() === 'err') return;
      }
      GetMobileVerificationCode({
        cityCode: this.cityCode,
        MobileNumber: this.mobileNum.replace(/\s/gi, ''),
        welcomeCode: welcomeCode,
        sourceType: this.inviteSourceType,
      })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 2020.11.6添加，输入邀请码后点击获取验证码，不允许再次输入邀请码
              if (!this.inviteCode && this.inviteName) {
                this.isNoGetSmsCode = false;
                this.inviteCodeDisabled = true;
              }
              let time = 60;
              this.codeBtnDisabled = true;
              const sendSms = function () {
                if (time > 0) {
                  this.codeBtnLabel = time + '秒后重新获取';
                  time -= 1;
                } else {
                  this.endTiming();
                }
                return sendSms;
              }.bind(this);
              this.timing = setInterval(sendSms(), 1000);
            },
            (code, msg) => {
              // 2020.11.6添加，未获得邀请资质时，提示是否继续
              // 如果继续则清空邀请码并进入倒计时
              if (code === 9073) {
                MessageBox({
                  title: '',
                  message: '尚未获得邀请资质',
                  showCancelButton: true,
                  confirmButtonText: '继续注册',
                  confirmButtonHighlight: true,
                  closeOnClickModal: false,
                }).then(action => {
                  if (action === 'confirm') {
                    this.inviteName = '';
                    this.apiGetMobileVerificationCode();
                  }
                });
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获取注册码（代理商使用）
    apiGetSMSCode(welcomeCode = '') {
      // 2020.8.28新加， 如果url传入的邀请码不存在，则认为允许客户输入邀请码
      // 允许客户输入邀请码时先校验邀请码
      // 再获取格式正确的邀请码
      // 2020.11.12新加，如果由url控制邀请码是否显示，则先验证邀请码，反之则验证手机号
      if (this.isUrlGetInviteCodeShow) {
        if (this.validateInviteCodeVal() === 'err') return;
        if (this.validateMobileNumVal() === 'err') return;
      } else {
        if (this.validateMobileNumVal() === 'err') return;
        if (this.validateInviteCodeVal() === 'err') return;
      }
      GetSMSCode({
        flag: 1,
        inviteCode: welcomeCode,
        mobile: this.mobileNum.replace(/\s/gi, ''),
      })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 2020.11.6添加，输入邀请码后点击获取验证码，不允许再次输入邀请码
              if (!this.inviteCode && this.inviteName) {
                this.isNoGetSmsCode = false;
                this.inviteCodeDisabled = true;
              }
              let time = 60;
              this.codeBtnDisabled = true;
              const sendSms = function () {
                if (time > 0) {
                  this.codeBtnLabel = time + '秒后重新获取';
                  time -= 1;
                } else {
                  this.endTiming();
                }
                return sendSms;
              }.bind(this);
              this.timing = setInterval(sendSms(), 1000);
            },
            (code, msg) => {
              // 2020.11.6添加，未获得邀请资质时，提示是否继续
              // 如果继续则清空邀请码并重新调用获取邀请码接口
              if (code === 9073) {
                MessageBox({
                  title: '',
                  message: '尚未获得邀请资质',
                  showCancelButton: true,
                  confirmButtonText: '继续注册',
                  confirmButtonHighlight: true,
                  closeOnClickModal: false,
                }).then(action => {
                  if (action === 'confirm') {
                    this.inviteName = '';
                    this.apiGetSMSCode();
                  }
                });
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，注册（商户使用）
    apiRegUser() {
      Indicator.open();
      const finalInviteCode = this.inviteCode || this.inviteName.replace(/\s/gi, '');
      RegUser({
        MobileNumber: this.mobileNum.replace(/\s/gi, ''),
        MobileNumberCode: this.validateCode,
        LoginPassword: this.pwd1,
        SharingSources: 'H5',
        welcomeCode: finalInviteCode,
        cityCode: this.cityCode,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.handleAddUserSuccess('注册成功');
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，注册（代理商使用）
    // 2021/3/9 新加参数，是否注册为业务员
    apiAddUser() {
      Indicator.open();
      const finalInviteCode = this.inviteCode || this.inviteName.replace(/\s/gi, '');
      AddUser({
        code: this.validateCode,
        inviteCode: finalInviteCode,
        mobile: this.mobileNum.replace(/\s/gi, ''),
        password: this.pwd1,
        registerBusinessPerson: this.inviteAgentType === '2',
        referralCode: this.referralCode,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.handleAddUserSuccess('注册成功');
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 手机号keyup事件
    handleMobileNumKeyUp() {
      const last = this.mobileNum.charAt(this.mobileNum.length - 1);
      // 自动将非法字符替换成空
      this.mobileNum = '1234567890 '.indexOf(last) < 0 ? this.mobileNum.replace(last, '') : this.mobileNum;
      // 第3位自动加空格，格式为：XXX XXXX
      if (this.mobileNum.length === 4 && last !== ' ') {
        const arr = this.mobileNum.split('');
        arr.splice(3, 0, ' ');
        this.mobileNum = arr.join('');
      }
      // 第8位自动加空格，格式为：XXX XXXX XXXX
      if (this.mobileNum.length === 9 && last !== ' ') {
        const arr = this.mobileNum.split('');
        arr.splice(8, 0, ' ');
        this.mobileNum = arr.join('');
      }
    },
    // 清除手机号click事件
    handleClearMobileNumClick() {
      this.mobileNum = '';
    },
    // 2020.8.28 邀请码keyup事件
    handleInviteCodeKeyUp() {
      const last = this.inviteName.charAt(this.inviteName.length - 1);
      // 自动将非法字符替换成空
      this.inviteName = '1234567890 '.indexOf(last) < 0 ? this.inviteName.replace(last, '') : this.inviteName;
      // 第3位自动加空格，格式为：XXX XXXX
      if (this.inviteName.length === 4 && last !== ' ') {
        const arr = this.inviteName.split('');
        arr.splice(3, 0, ' ');
        this.inviteName = arr.join('');
      }
      // 第8位自动加空格，格式为：XXX XXXX XXXX
      if (this.inviteName.length === 9 && last !== ' ') {
        const arr = this.inviteName.split('');
        arr.splice(8, 0, ' ');
        this.inviteName = arr.join('');
      }
    },
    // 2024.4.25 销售码
    handleReferralCodeKeyUp() {
      const last = this.referralCode.charAt(this.referralCode.length - 1);
      // 自动将非法字符替换成空
      this.referralCode = '1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.indexOf(last) < 0 ? this.referralCode.replace(last, '') : this.referralCode;
    },
    // 2020.8.28 清除邀请码click事件
    handleClearInviteCodeClick() {
      this.inviteName = '';
    },
    // 短信验证码keyup事件
    handleCodeKeyUp() {
      const last = this.validateCode.charAt(this.validateCode.length - 1);
      // 自动将非法字符替换成空
      this.validateCode = '1234567890'.indexOf(last) < 0 ? this.validateCode.replace(last, '') : this.validateCode;
    },
    // 获取验证码按钮click事件
    handleCodeBtnClick() {
      const finalInviteCode = this.inviteCode || this.inviteName.replace(/\s/gi, '');
      // 根据标识调用不同接口
      switch (PUBLIC_REGISTER_INTERFACE_FLAG) {
        case '商户':
          this.apiGetMobileVerificationCode(finalInviteCode);
          break;
        case '代理商':
          this.apiGetSMSCode(finalInviteCode);
          break;
      }
    },
    // 密码1keyup事件
    handlePwd1KeyUp() {
      const last = this.pwd1.charAt(this.pwd1.length - 1);
      // 自动将非法字符替换成空
      this.pwd1 = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? this.pwd1.replace(last, '') : this.pwd1;
      // 自动将汉字符替换成空
      this.pwd1 = this.pwd1.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 显示密码1
    handleShowPwd1Click() {
      if (this.pwd1SvgEyePath === 'hide_money') {
        this.pwd1SvgEyePath = 'show_money';
        this.pwd1InputType = 'text';
      } else {
        this.pwd1SvgEyePath = 'hide_money';
        this.pwd1InputType = 'password';
      }
    },
    // 密码2keyup事件
    handlePwd2KeyUp() {
      const last = this.pwd2.charAt(this.pwd2.length - 1);
      // 自动将非法字符替换成空
      this.pwd2 = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? this.pwd2.replace(last, '') : this.pwd2;
      // 自动将汉字符替换成空
      this.pwd2 = this.pwd2.replace(/[\u4E00-\u9FA5]/g, '');
    },
    // 显示密码2
    handleShowPwd2Click() {
      if (this.pwd2SvgEyePath === 'hide_money') {
        this.pwd2SvgEyePath = 'show_money';
        this.pwd2InputType = 'text';
      } else {
        this.pwd2SvgEyePath = 'hide_money';
        this.pwd2InputType = 'password';
      }
    },
    // 同意协议checkbox的change
    handleCheckBoxClick() {
      this.currentCheckedState = !this.currentCheckedState;
      this.registerBtnDisabled = !this.currentCheckedState;
      this.checkboxSvgPath = this.currentCheckedState ? 'selected_coupons' : 'unselected_coupons';
    },
    // 下载按钮click事件
    handleDownloadBtnClick() {
      this.handleAddUserSuccess('尚未开通此APP的下载');
    },
    // 注册按钮click事件
    handleRegisterBtnClick() {
      // 点击按钮的控件验证
      if (this.isUrlGetInviteCodeShow && this.validateInviteCodeVal() === 'err') return;
      if (this.validateMobileNumVal() === 'err') return;
      if (this.validateCodeVal() === 'err') return;
      if (this.validatePwd1Val() === 'err') return;
      if (this.validatePwd2Val() === 'err') return;
      // 根据标识调用不同接口
      switch (PUBLIC_REGISTER_INTERFACE_FLAG) {
        case '商户':
          this.apiRegUser();
          break;
        case '代理商':
          this.apiAddUser();
          break;
      }
    },
    // 缓存页面信息
    handleToAgreementClick() {
      this.agreementVisible = true;
    },
    // 关闭协议窗口事件
    handleAgreementClose() {
      this.agreementVisible = false;
    },
    // 处理添加用户成功事件
    handleAddUserSuccess(msg) {
      // 判断是否是扫二维码进到此页面
      if (this.isQrCode) {
        // 是，则注册成功后跳转APP下载页面
        const key = PUBLIC_PRODUCT.toLowerCase().trim();
        switch (PUBLIC_SYSTEM_FLAG) {
          case 'android':
            if (android_download_url[key]) {
              if (Array.isArray(android_download_url[key])) {
                switch (android_download_url[key].length) {
                  case 1:
                    if (android_download_url[key][0].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                  case 2:
                    if (android_download_url[key][0].url && android_download_url[key][1].url) {
                      this.$router.push('/download');
                    } else CusToast(msg);
                    break;
                }
              } else {
                CusToast(msg);
              }
            } else {
              CusToast(msg);
            }
            break;
          case 'ios':
            if (ios_download_url[key]) {
              if (Array.isArray(ios_download_url[key])) {
                switch (ios_download_url[key].length) {
                  case 1:
                    if (ios_download_url[key][0].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                  case 2:
                    if (ios_download_url[key][0].url && ios_download_url[key][1].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                }
              } else {
                CusToast(msg);
              }
            } else {
              CusToast(msg);
            }
            break;
        }
      } else {
        // 反之，则注册成功后发请求到APP，APP去处理下一步如何进行
        CusToast(msg);
        window.location.href = 'registerok://android';
      }
    },
  },
};
</script>
